import { useCallback } from "react";

import Analytics, { type Event } from "$src/core/services/analytics/analytics";

const useAnalytics = () => {
  const setUserProperty = useCallback((name: string, value: string) => {
    Analytics.setUserProperty(name, value);
  }, []);

  const trackEvent = useCallback(
    <N extends Event["name"]>(
      name: N,
      params?: Omit<Extract<Event, { name: N }>, "name">,
    ) => {
      const payload: Event = { name, ...params } as Extract<Event, { name: N }>;
      Analytics.trackEvent(payload);
    },
    [],
  );

  return {
    setUserProperty,
    trackEvent,
  };
};

export default useAnalytics;
